
import { LocalStorageKeys } from '../../../common/constant/constantKey';
import { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import jwt_decode from 'jwt-decode'
import *  as Api from '../../../api/src';

const TokenApi = new Api.TokenApi()
const useCheckToken = () => {
    const getToken = () => {
        const tokenString = localStorage.getItem(LocalStorageKeys.Token);
        if (!tokenString) {
            return "";
        }
        const userToken = JSON.parse(tokenString);
        return userToken?.Token
    };
    const [token, setToken] = useState(getToken());
    return {
        setCheckToken: setToken,
        tokenCheck: token,
        getToken: getToken,
    }
}
export default useCheckToken;